module.exports = __webpack_public_path__ + "static/media/correct-ans2.afeddd55.mp3";